import reportFrontendIncident from '../monitoring/reportFrontendIncident';

const EXPECTED_CLOSE_MESSAGE = 'Connection closed';

function messageOf(error) {
	if (typeof error === 'string') return error;
	return error?.message || 'Ably subscription failed';
}

/**
 * Starts an Ably channel subscription and handles the promise that Ably uses
 * while the channel is attaching. React can unmount the owner before that
 * attach completes; in that one intentional-cleanup case Ably rejects with
 * "Connection closed". All other failures remain visible to monitoring.
 */
export function subscribeToAblyChannel({ channel, eventName, listener }) {
	let isCleaningUp = false;
	const subscription = channel.subscribe(eventName, listener);

	Promise.resolve(subscription).catch((error) => {
		if (isCleaningUp && messageOf(error) === EXPECTED_CLOSE_MESSAGE) {
			return;
		}

		reportFrontendIncident({
			type: 'ably-realtime-error',
			message: messageOf(error),
			stack: error?.stack || null,
			metadata: {
				event_name: eventName,
				reason_type: error?.name || typeof error,
			},
		});
	});

	return () => {
		isCleaningUp = true;
		channel.unsubscribe(eventName, listener);
	};
}
